import * as React from "react";
import styled, { css } from "styled-components";
import { ExternalLink } from "components/common";
import CVSSHeatBadge from "./CVSSHeatBadge";
import { DOCS_BY_SCANNER_TYPE, ID_LABEL_BY_SCANNER_TYPE, NVD_CVE_URL } from "./constants";
const VulnerabilityIds = styled.div`
  display: flex;
  flex-direction: column;
`;
const CVSSCell = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.sm};
    white-space: nowrap;
  `
);
const VulnerabilityId = ({ vuln }) => {
  if (!vuln.vulnerability_id) return null;
  const label = (ID_LABEL_BY_SCANNER_TYPE[vuln.scanner_type] || "") + vuln.vulnerability_id;
  return DOCS_BY_SCANNER_TYPE[vuln.scanner_type] ? /* @__PURE__ */ React.createElement(ExternalLink, { href: DOCS_BY_SCANNER_TYPE[vuln.scanner_type] + encodeURIComponent(vuln.vulnerability_id) }, label) : /* @__PURE__ */ React.createElement("span", null, label);
};
const columnRenderers = {
  attributes: {
    cve: {
      renderCell: (_cve, vuln) => /* @__PURE__ */ React.createElement(VulnerabilityIds, null, vuln.cve && /* @__PURE__ */ React.createElement(ExternalLink, { href: NVD_CVE_URL + encodeURIComponent(vuln.cve) }, vuln.cve), /* @__PURE__ */ React.createElement(VulnerabilityId, { vuln }))
    },
    application: {
      renderCell: (application) => application || "N/A"
    },
    cvss: {
      renderCell: (_cvss, vuln) => /* @__PURE__ */ React.createElement(CVSSCell, null, (vuln.cvss || 0).toFixed(1), /* @__PURE__ */ React.createElement(CVSSHeatBadge, { rating: vuln.cvss_rating }))
    },
    cvss_rating: {
      renderCell: (_rating, vuln) => /* @__PURE__ */ React.createElement(CVSSHeatBadge, { rating: vuln.cvss_rating })
    }
  }
};
export default columnRenderers;
